<template>
    <paper class="appointmentCenter">
        <el-main v-loading="mainLoading"
                 class="main-loading">
            <m-pane ref="tablePage"
                    :config="config"
                    :totalData="totalData"
                    :totalTargetData="totalTargetData"
                    :sourceRootData="sourceTree"
                    :mulSourceSel="true"
                    :pageTotal="pageTotal"
                    :searchTotalTitle="searchTotalTitle"
                    :initSearchInfo="initSearchInfo"
                    :optionNum="optionNum"
                    :loading="loading"
                    :verification="verification"
                    :sourceTitle="sourceTitle"
                    :columnNum="columnNum"
                    searchId="appointment-center_query"
                    pageID="appointment-center"
                    @searchChange="searchChange"
                    @search-list-change="searchListChange"
                    @searchSet-change="searchSetChange"
                    @root-click="rootClick"
                    @source-select-change="sourceSelChange"
                    @cellDblclick="cellDblclick"
                    @sourceSelect="sourceSelect"
                    @sourceRowClick="sourceRowClick"
                    @remove-btn="removeBtn"
                    @allocation-btn="allocationBtn"
                    @rescheduling-btn="removeBtn"
                    @row-db-click="rowDBclick"
                    @appointmentBranch-btn="appointmentBranchBtn"
                    @rescheduledBranch-btn="rescheduledBranchBtn">
                <template v-slot:customTableCell="{ row,col }">
                    <div>
                        <el-button
                            type="text"
                            size="mini"
                            @click.stop='taskNoClick(row.taskNo)'>
                            {{row.taskNo }}
                        </el-button>
                        <el-button
                            type="text"
                            size="mini"
                            class="el-icon-document-copy table-module-btn-taskNo"
                            @click.stop='copyTaskNoClick(row.taskNo)'>
                        </el-button>
                    </div>
                </template>
                <div slot="table-module-btn"
                     class="table-module-btn">
                    <reportExport #default="{ submit }"
                                  reportCode="REPORT_APPOINTMENT_CENTER">
                        <el-tooltip effect="dark"
                                    content="导出"
                                    placement="bottom">
                            <span class="mgr-10">
                                <el-button icon="icon-daochu"
                                           size="mini"
                                           @click="exportFile(submit)"></el-button>
                            </span>
                        </el-tooltip>
                    </reportExport>
                </div>
                <div slot="table-top">
                <div>
                    <span class="left-info collect">
                     <span>汇总：<span class="content"></span></span>
                        <span>单量：
                            <span class="content">{{ filterCheckedSourceListCount}}</span>
                        </span>
                        <span>数量：
                            <span class="content">{{ taskTotalCount}}</span>
                        </span>
                        <span>方量(m³)：
                            <span class="content">{{ taskTotalVolume}}</span>
                        </span>
                        <span>重量(KG)：
                            <span class="content">{{ taskTotalWeight}}</span>
                        </span>
                    </span>
                    <el-button type="primary" class="mgl-10 btn-style" @click="productDetail">商品明细</el-button>
                </div>
            </div>
                <div slot="page-module-btn">
                    <el-button class="mgl-10"
                               type="primary"
                               @click="allocationBatch">批量分配</el-button>
                    <el-button class="mgl-10"
                               type="primary"
                               @click="removeBatch">批量预约</el-button>
                </div>
            </m-pane>
        </el-main>
        <!-- 正向批量预约 -->
        <BatchAppointDialog ref="batchAppointDialog"
                            :title="title"
                            @showTips="showAppointTipsDialog"
                            @remove="removeBtn"
                            @success="dialogConfirm">
        </BatchAppointDialog>
        <!-- 逆向批量预约 -->
        <appointment-branch-dialog ref="appointmentBranchDialog"
                                   :title="title"
                                   @success="dialogConfirm">
        </appointment-branch-dialog>
        <!-- 预约提示 -->
        <AppointTipsDialog ref="appointTipsDialog">
        </AppointTipsDialog>
        <!-- 分配弹窗 -->
        <allocation-dialog v-if="allocationDialogVisible"
                           :allocationDialogVisible.sync="allocationDialogVisible"
                           :taskDataList="allocationList"
                           @allocationDialogConfirm="dialogConfirm"></allocation-dialog>
         <!-- 明细弹窗 -->
        <DetailDialog
            :detailVisible.sync="rowDetailVisible"
            :totalNum="totalNum"
            :totalAmount="totalAmount"
            :detailStatistics="rowDtailData"
        />
    </paper>
</template>
<script>
import _ from 'lodash';
import mPane from './mPanel';
import config from './config.json';
import paper from '@/components/core/paper/Paper';
import { dictWithUrl } from '@/components/lots/api.js';
import { getSourceRoot, getSourceData, getServeRule, getUserSiteCodeApi,getServeRuleSwitchQueryApi,getInventoryData } from '../../../../api/appointmentCenter';
import { groupPolicyObj } from '../../../../utils/dispatchCenter.js';
import BatchAppointDialog from './appointment/BatchAppointDialog';
import AppointTipsDialog from './components/AppointTipsDialog';
import AllocationDialog from './components/AllocationDialog';
import storage from '../../../../utils/storage.js';
import storeConfig from '../../../../utils/storeConfig';
import { mapState } from 'vuex';
import { formatTableData, formatSearchParams, checkSearchParams, isRiOrRriOrDpri, isDOTOrNet, filterSupportAlloc } from '../util';
import reportExport from '@/components/lots/reportExportPlugin';
import AppointmentBranchDialog from './appointment/AppointmentBranchDialog';
import DetailDialog from './appointment/DetailDialog';

export default {
    name: 'appointmentCenter',
    components: { mPane, paper, BatchAppointDialog, AppointTipsDialog, AllocationDialog, reportExport, AppointmentBranchDialog, DetailDialog },
    data () {
        return {
            checkedSourceList: [],
            allocationList: [],// 分配选中数据
            config,
            loading: false,
            groupPolicy: '',
            groupPolicyCode: '',
            targetTableLoading: false,
            sourceTitle: '全部',
            sourceTree: [],
            sourceSelectedRoot: {},
            optionNum: 'TMS_SHIPPING_TYPE,TRANSPORT_STATUS,DELIVERY_TYPE,ORDER_TYPE,NATIONAL_SUBSIDY_TIME',
            totalData: [],
            siteCodes: [],
            totalTargetData: [], // 手工排车表格数据
            pageTotal: 0,
            searchParams: {},
            searchTotalTitle: config.table.searchTotalTitle,
            verification: {},
            mainLoading: false,
            isFirstSearch: true,
            targetTotalListPage: {
                pageNo: 1,
                pageSize: 1000000,
                total: 0
            },
            columnNum: 18,
            currentSourceSelectRow: {},
            serveRule: [],
            appointVisible: false, // 行预约显隐
            allocationDialogVisible: false, // 分配显隐
            selectedRootList: [],
            initSearchInfo: {}, // 初始化查询数据
            title: '预约网点',
            serveRuleSwitchQuery: 0,// 筛单规则新逻辑开关标识
            rowDtailData: [],
            adressNoList: [], // 纠编弹窗-任务单号
            totalAmount: 0,
            totalNum: 0,
            rowDetailVisible: false
        };
    },
    methods: {
        // 批量查看商品明细
        productDetail () {
            if (!this.checkedSourceList.length) {
                return this.$message.warning('请先勾选运输单');
            }
            this.rowDtailData = [];
            this.rowDetailVisible = true;
            const params = {
                pageNo: 1,
                pageSize: 1000,
                taskNoList: this.checkedSourceList.map(v => v.taskNo)
            };
            getInventoryData(params).then(res => {
                if (res && +res.code === 0 && res.data) {
                    this.rowDtailData = res.data.list || [];
                    this.totalNum = this.rowDtailData.reduce((pre, cur) => { return pre + cur.planQty; }, 0);
                    this.totalAmount = this.rowDtailData.reduce((pre, cur) => { return pre + cur.volume; }, 0).toFixed(2);
                }
            });
        },
        // 双击列表
        rowDBclick (data) {
            this.$router.push({
                query: { rowData: data },
                path: `/otp/appointment-center-detail`
            });
        },
        // 点击tk单号
        taskNoClick (taskNo) {
            this.$router.push({
                query: { taskNo },
                path: '/otp/distribute/transport-details'
            });
        },
        // 分配
        allocationBtn (data) {
            const list = filterSupportAlloc([data]);
            if (list && list.length) {
                this.allocationList = [data];
                this.allocationDialogVisible = true;
            }
        },
        // 批量分配
        allocationBatch () {
            if (!this.checkedSourceList.length) { return this.$message.warning('请勾选运输单'); }
            const list = filterSupportAlloc(this.checkedSourceList);
            if (list && list.length) {
                this.allocationList = list;
                this.allocationDialogVisible = true;
            }
        },
        leftList () {
            this.totalData = [];
            this.allocationDialogVisible = false;
            this.$refs.tablePage.$refs.searchList.onSearchChange();
        },
        async dialogConfirm () {
            this.totalData = [];
            this.selectedRootListIndex = 0;
            await this.getSourceData();
            this.allocationDialogVisible = false;
        },
        async getSourceData () {
            this.$refs.tablePage.sourceLoading = true;
            this.sourceSelectedRoot = this.selectedRootList[this.selectedRootListIndex];
            const data = Object.assign({}, this.searchParams, { pageSize: 1000 });
            data.taskNoList = this.sourceSelectedRoot.taskNoList;
            groupPolicyObj.forEach(item => {
                if (item.name === this.groupPolicy) {
                    data[item.code] = this.sourceSelectedRoot[item.code] || '';
                }
            });
            await getSourceData(data).then(resp => {
                if (resp) {
                    const resData = resp.data.list || [];
                    this.totalData = this.totalData.concat(resData);
                    this.totalData = formatTableData(this.totalData || [], this.dictData);
                    this.selectedRootListIndex++;
                    if (this.selectedRootListIndex < this.selectedRootList.length) {
                        this.getSourceData();
                    }
                    if (this.selectedRootListIndex === this.selectedRootList.length - 1 || this.selectedRootList.length === 1) {
                        this.$refs.tablePage.sourceLoading = false;
                    }
                }
            }).catch(() => {
                this.$refs.tablePage.sourceLoading = false;
            });
        },
        async getDictList () {
            const dict = await dictWithUrl(this.optionNum);
            this.dictData = dict.data;
        },
        // 查询分组下的tk单集合
        initTransportList () {
            this.$refs.tablePage.sourceLoading = true;
            const data = Object.assign({}, this.searchParams, { pageSize: 1000 });
            data.taskNoList = this.sourceSelectedRoot.taskNoList;
            groupPolicyObj.forEach(item => {
                if (item.name === this.groupPolicy) {
                    this.groupPolicyCode = item.code;
                    data[item.code] = this.sourceSelectedRoot[item.code] || '';
                }
            });
            getSourceData(data).then(resp => {
                this.$refs.tablePage.sourceLoading = false;
                if (resp) {
                    this.sourceSelectedRoot.isActive = !this.sourceSelectedRoot.isActive;
                    const resData = resp.data.list || [];
                    if (this.sourceSelectedRoot.isActive) {
                        this.totalData = this.totalData.concat(resData);
                    } else {
                        const resDataGroupPolicyCode = resData.map(el => el[this.groupPolicyCode]);
                        this.totalData = this.totalData.filter(el => !resDataGroupPolicyCode.includes(el[this.groupPolicyCode]));
                    }
                    this.isActiveSelectedRoot();
                    this.totalData = formatTableData(this.totalData || [], this.dictData);
                }
            }).catch(() => {
                this.$refs.tablePage.sourceLoading = false;
            });
        },
        isActiveSelectedRoot () {
            if (this.sourceSelectedRoot.isActive) {
                this.selectedRootList.push(this.sourceSelectedRoot);
            } else {
                this.selectedRootList = this.selectedRootList.filter(item => item[this.groupPolicyCode] !== this.sourceSelectedRoot[this.groupPolicyCode]);
            }
        },
        searchChange (data) {
            // 格式化参数
            const searchParms = formatSearchParams(data, this);
            // 查询条件限制校验
            const isCheckOK = checkSearchParams(searchParms);
            if (!isCheckOK) return false;
            this.searchParams = {
                appointmentCenterFlag: true,
                ...searchParms,
                carrierVisibleFlag: 'Y',
                carrierCode: this.supplier.supplierCode
            };
            const siteCodeInfo = {
                escoCompanyNo: data.siteCode,
                escoCompanyNameCn: data.siteName
            };
            window.localStorage.setItem(this.user.userCode, JSON.stringify(siteCodeInfo));
            delete this.searchParams.siteCode;
            delete this.searchParams.siteName;
            for (const key in this.searchParams) {
                if (this.searchParams[key] === '') {
                    delete this.searchParams[key];
                }
            }
            if (this.searchParams.vipFlagList && !this.searchParams.vipFlagList.length) delete this.searchParams.vipFlagList;
            // 有坑：这里chooseCode删除逻辑是根据查询字段来的，如果有新的查询字段除了在config添加也要在这笨方法的也对应加入
            if (this.serveRuleSwitchQuery === 0) {
                for (const key in this.searchParams) {
                    // eslint-disable-next-line max-len, standard/array-bracket-even-spacing
                    if (!['chooseCode', 'beginDate', 'endDate', 'groupPolicy', 'taskStatusList', 'appointmentFlag', 'siteCodes', 'allocationStatus', 'arriveAppointmentRequireFlag', 'appointmentCenterFlag', 'appointmentChangeFirstReasonType', 'appointmentChangeSecondReasonTypeList', 'appointmentTaskCreateTimeFrom', 'appointmentTaskCreateTimeTo', 'appointmentTimeFrom', 'appointmentTimeTo', 'beginDate1', 'endDate1', 'requireArriveTimeBegin', 'requireArriveTimeEnd', 'appointmentExceptionTypeList', 'carrierVisibleFlag', 'carrierCode', 'waveIdList', 'custOrderNos', 'batchQueryKey', 'batchQueryValue', 'taskNoList', 'dispatchNoList', 'orderNoList','collectNoList', 'consolidationOrderNoList', 'serviceTypeList'].includes(key)) {
                        delete this.searchParams.chooseCode;
                    }
                }
            }
            this.isFirstSearch = false;
            this.getSourceRootData(data);
        },
        searchListChange (config, data) {
            if (config.name === '服务平台') {
                this.siteCodes = data.siteCode ? data.siteCode.split(',') : [];
                this.getServeRules(this.siteCodes);
            }
        },
        searchSetChange (data) {

        },
        /**
         * @desc 获取分组策略数据
         * @param {*} data 查询参数
         */
        async getSourceRootData (data) {
            this.$refs.tablePage.changeLoading(true);
            this.$refs.tablePage.sourceTreeLoading = true;
            await getSourceRoot(this.searchParams).then(resp => {
                this.$refs.tablePage.changeLoading(false);
                this.$refs.tablePage.sourceTreeLoading = false;
                if (resp) {
                    const sourceTree = resp.data.list;
                    if (sourceTree) {
                        sourceTree.forEach(root => {
                            root.isActive = false;
                            root['textLeft'] =
                                `${root[this.groupPolicy] ? root[this.groupPolicy] : ' '}
                                ${root.totalVolume ? root.totalVolume.toFixed(2) : 0}m³/${root.totalWeight ? root.totalWeight.toFixed(2) : 0}KG/${root.totalQty || '0'}台/${root.taskCount || '0'}单`;
                        });
                    }
                    this.sourceTree = sourceTree;
                    if (data.appointmentFlag === '1') {
                        this.sourceTitle = '已预约';
                    } else if (data.appointmentFlag === '0') {
                        this.sourceTitle = '未预约';
                    } else {
                        this.sourceTitle = '全部';
                    }
                    this.selectedRootList = [];// 清空左边分组策略点击记录
                }
            }).finally(() => {
                this.$refs.tablePage.changeLoading(false);
                this.$refs.tablePage.sourceTreeLoading = false;
            });
            this.$refs.tablePage.initActiveChange();
        },
        // 批量预约
        removeBatch () {
            if (!this.checkedSourceList.length) {
                return this.$message.warning('请勾选运输单');
            }
            if (this.checkedSourceList.length > 1 && this.checkedSourceList.some(i => { return i.projectClassify === 'XB_SHOP_RI'; })) {
                return this.$message.warning('门店退货订单不允许批量改约');
            }
            if (this.checkedSourceList.some(i => i.appointmentTypeExt === 'INTEGRATE') && !this.checkedSourceList.every(i => i.appointmentTypeExt === 'INTEGRATE')) {
                return this.$message.warning('您所选单据包含新送装服务类型单据，该单据仅支持精准预约，不能混选，请移除其中一类后再进行批量预约.要操作批量 精准预约，则只能勾选同一类型订单');
            } else if (this.checkedSourceList.every(i => i.appointmentTypeExt === 'INTEGRATE')) {
                // 针对新送装服务的单子
                if (this.checkedSourceList.some(i => +i.taskStatus < 40) && this.checkedSourceList.some(i => +i.taskStatus >= 40)) {
                    return this.$message.warning('不能同时勾选未发车、已发车状态的新送装服务单据进行批量预约');
                }
            }

             if (this.checkedSourceList.some(i => { return i.orderType === 'PO' && i.isJzp === 'Y'; }) && this.checkedSourceList.some(i => { return i.orderType !== 'PO' || (i.orderType === 'PO' && i.isJzp !== 'Y'); })) {
                 return this.$message.warning('精准配送单不能和非精准配送单一起预约');
            }
             if (this.checkedSourceList.length > 1 && this.checkedSourceList.some(i => { return i.enableProvideHomeDelivery; }) &&
                !this.checkedSourceList.every(i => i.customerOrderNo === this.checkedSourceList[0].customerOrderNo)) {
                return this.$message.warning('不同客户订单号的2C直配且非上楼订单无法进行批量改约');
            }
            // 菜鸟国补支签限制订单,卡控无法批量操作
            const guoBuTaskList = this.checkedSourceList.filter(v => v.sourceSystem === 'CAINIAO' && v.orderTypeExt === 'STATE_SUBSIDIES' && v.appointLimitDays && v.payDate);
            if (guoBuTaskList.length && this.checkedSourceList.length > 1) {
                return this.$message.warning('存在菜鸟国补支签限制订单，无法批量预约和改约!');
            }
            const isRiOrRriOrDpriList = [];
            const isB2CRiOrRriOrDpriList = [];
            const reverseTaskList = [];
            const B2BAndRi = [];
            this.checkedSourceList.forEach(v => {
                // 正向 订单类型为退货入库单或上门取件单
                if (isRiOrRriOrDpri(v)) {
                    isRiOrRriOrDpriList.push(v);
                }
                // B2C订单，订单类型为退货入库单或上门取件单且配送方式为网点配送或宅配时
                if (v.businessMode === 'B2C' && isRiOrRriOrDpri(v) && isDOTOrNet(v)) {
                    isB2CRiOrRriOrDpriList.push(v);
                }
                // 订单类型=上门取件退货单、退货入库单 & 配送方式=网点配送、宅配
                if (isRiOrRriOrDpri(v) && isDOTOrNet(v)) {
                    reverseTaskList.push(v);
                }
                // 订单类型=退货入库单 && 业务模式为B2B
                if (v.orderType === 'RI' && v.businessMode === 'B2B') {
                    B2BAndRi.push(v);
                }
            });
            if (isRiOrRriOrDpriList.length && isRiOrRriOrDpriList.length !== this.checkedSourceList.length) {
                return this.$message.warning('订单类型为退货入库单或上门取件单不能与其他类型订单一起预约');
            }
            if (isB2CRiOrRriOrDpriList.length && isB2CRiOrRriOrDpriList.length !== this.checkedSourceList.length) {
                return this.$message.warning('B2C订单，订单类型为退货入库单或上门取件单且配送方式为网点配送或宅配时，不能和其他订单类型+配送方式一起预约');
            }
            // if (B2BAndRi.length && B2BAndRi.length !== this.checkedSourceList.length) {
            //     return this.$message.warning('订单类型为退货入库单且业务模式为B2B不能和其它订单类型+业务模式一起预约');
            // }
            if (reverseTaskList.length) {
                this.title = '批量预约网点';
                this.$refs.appointmentBranchDialog.show(this.checkedSourceList);
                return false;
            }
            this.title = '批量预约';
            this.$refs.batchAppointDialog.show(this.checkedSourceList);
        },
        // 预约||改约
        removeBtn (data) {
            const list = filterSupportAlloc([data]);
            if (list && list.length) {
                this.title = '预约';
                this.$refs.batchAppointDialog.show([data, {}]);
            }
        },
        // 预约网点
        appointmentBranchBtn (rowData) {
            this.title = '预约网点';
            this.$refs.appointmentBranchDialog.show([rowData]);
        },
        // 改约网点
        rescheduledBranchBtn (rowData) {
            this.title = '改约网点';
            this.$refs.appointmentBranchDialog.show([rowData]);
        },
        showAppointTipsDialog () {
            const appointRecord = storage.getExpireLocal(storeConfig.task_appoint);
            !appointRecord && this.$refs.appointTipsDialog.show();
        },
        // 点击左边分组
        rootClick (item) {
            this.sourceSelectedRoot = item;
            this.initTransportList();
        },
        sourceSelChange (selection) {
            this.checkedSourceList = selection;
            const selctedTaskNos = this.checkedSourceList.map(item => item.taskNo);
            this.currentSourceSelectRow.checked = selctedTaskNos.includes(this.currentSourceSelectRow.taskNo);
            const moduleTable = _.get(this, '$refs.tablePage.$refs.table.$refs.moduleTable', {});
            this.checkSameLbxOrder(this.currentSourceSelectRow, moduleTable);
        },
        sourceSelect (selection, row) {
            this.currentSourceSelectRow = row;
        },
        sourceRowClick (row) {
            const moduleTable = _.get(this, '$refs.tablePage.$refs.table.$refs.moduleTable', {});
            this.checkSameLbxOrder(row, moduleTable);
        },
        checkSameLbxOrder (row, moduleTable) {
            // 天猫优品的单勾选一条相同客户订单号的全部选中（展示中的数据）
            if (row.businessMode === 'B2B' && ['OUT', 'DO'].includes(row.taskType) && row.sourceSystem === 'CAINIAO') {
                const sameLbxOrder = moduleTable.tableData.filter(item => item.customerOrderNo === row.customerOrderNo);
                sameLbxOrder.forEach(item => {
                    moduleTable.toggleRowSelection(item, row.checked);
                });
            }
        },
        copyTaskNoClick (taskNo) {
            this.copyText(taskNo);
        },
         // 复制
        copyText (copyText) {
            var input = document.createElement('input');
            input.type = 'text';
            input.value = copyText.trim();
            document.body.appendChild(input);
            input.select();
            document.execCommand('copy');
            document.body.removeChild(input);
            this.$message.success(`‘${input.value}’复制成功`);
        },
        cellDblclick (row, column, cell, event) {
            // copyToClip(cell.children[0].innerHTML);
        },
        // 导出
        exportFile (submit) {
            let exportParams = {};
            this.isFirstSearch && this.$refs.tablePage.$refs.searchList.onSearchChange();
            if (this.searchParams.chooseCode) {
                this.serveRule.forEach(item => {
                    if (item.chooseCode === this.searchParams.chooseCode) {
                        exportParams = item.dispatchCentreRequest;
                    }
                });
            }
            submit({
                ...this.searchParams,
                ...exportParams,
                appointmentCenterFlag: true,

            });
            this.isFirstSearch = true;
        },
        // 获取筛单规则
        getServeRules (siteCodes) {
            getServeRule({siteCodes}).then(res => {
                if (res && +res.code === 0) {
                    this.serveRule = res.data || [];
                    const option = [];
                    res.data.forEach(item => {
                        option.push({ 'value': item.chooseCode, 'label': item.chooseName });
                    });
                    // 踩坑点：不要用this.config.searchList.searchTxt[1]数组下标的方法修改配置，尽量遍历匹配对应的value值的
                    const targetConfig = this.config.searchList.searchTxt.find(item => item.value === 'chooseCode');
                    if (targetConfig) {
                        targetConfig.options = option;
                    }
                }
            });
            getServeRuleSwitchQueryApi({}).then(res => {
                if (res && +res.code === 0) {
                    this.serveRuleSwitchQuery = res.data || 0;
                }
            }).catch(() => {
                this.serveRuleSwitchQuery = 0;
            });
        },
        // 获取用户服务平台权限
        async getUserSiteCode () {
            await getUserSiteCodeApi({ 'pageSize': 10, 'pageNo': 1 }).then(res => {
                if (res && +res.code === 0) {
                    if (res.data && res.data.list.length === 1) {
                        if (res.data.list[0].siteName !== 'ALL') {
                            let initSearchInfo = res.data.list[0];
                            this.setUserCode(initSearchInfo);
                        }
                    }
                }
            });
        },
        setUserCode (initSearchInfo) {
            this.$set(this.initSearchInfo, 'siteName', initSearchInfo.escoCompanyNameCn);
            this.$set(this.initSearchInfo, 'siteCode', initSearchInfo.escoCompanyNo);
            this.$nextTick(() => {
                // 配置服务平台名称搜索条件的传参以及默认值
                this.$refs.tablePage.$refs.searchList.searchData.siteName = initSearchInfo.escoCompanyNameCn;
                this.$refs.tablePage.$refs.searchList.searchData.siteCode = initSearchInfo.escoCompanyNo;
                // 解决 服务平台 点击清空icon 不生效的问题
                this.$refs.tablePage.$refs.searchList.keyMap = {
                    siteCode: ['siteCode', 'siteName'],
                    siteName: ['siteCode', 'siteName']
                };
            });
            this.siteCodes = initSearchInfo.escoCompanyNo ? initSearchInfo.escoCompanyNo.split(',') : [];
            // 获取筛单规则;
            this.getServeRules(this.siteCodes);
        }
    },
    async mounted () {
        this.getDictList();

        await this.getUserSiteCode();
        // 获取本地缓存的服务平台数据
        const initSearchInfo = localStorage.getItem(this.user.userCode);
        if (initSearchInfo) {
            // 配置服务平台名称搜索条件的传参以及默认值
            this.setUserCode(JSON.parse(initSearchInfo));
        } else {
            // 获取筛单规则;
            this.getServeRules(this.siteCodes);
        }
    },
    activated () {
        // 获取本地缓存的服务平台数据
        const initSearchInfo = localStorage.getItem(this.user.userCode);
        if (initSearchInfo) {
            // 配置服务平台名称搜索条件的传参以及默认值
            this.setUserCode(JSON.parse(initSearchInfo));
        } else {
            // 获取筛单规则
            this.getServeRules(this.siteCodes);
        }
    },
    computed: {
        filterCheckedSourceListCount: function () {
            return this.checkedSourceList.length;
        },
        taskTotalVolume: function () {
            return this.checkedSourceList.reduce((partical, value) => {
                const taskTotalVolume = partical + (value.totalVolume || 0);
                return Math.round(taskTotalVolume * 1000000) / 1000000;
            }, 0);
        },
        taskTotalWeight: function () {
            return this.checkedSourceList.reduce((partical, value) => {
                const taskTotalWeight = partical + (value.totalGrossWeight || 0);
                return Math.round(taskTotalWeight * 1000) / 1000;
            }, 0);
        },
        taskTotalCount: function () {
            return this.checkedSourceList.reduce((partical, value) => {
                const taskTotalCount = partical + (value.totalQty || 0);
                return Math.round(taskTotalCount * 1000) / 1000;
            }, 0);
        },
        ...mapState({
            supplier: state => state.supplier,
            user: state => state.user
        }),
    }
};
</script>
<style lang="less">
@import './Main.less';
</style>
